import { Box, Heading, Container } from "@chakra-ui/react";
import { usePaginator } from "chakra-paginator";
import { ReactElement, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoadingScreen from "components/loading-screen";
import LogosTable from "components/table";
import MemberService from "services/members/member-service";
import Layout from "scenes/layouts";
import LogosTablePagination from "components/table/table-pagination";
import LogosTableSearch from "../../components/table/table-search";

const MemberScene = (): ReactElement => {
    const navigate = useNavigate();
    const [members, setMembers] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [totalMember, setTotalMember] = useState<number>(0);
    const [searchKey, setSearchKey] = useState<string>("");

    const {
        pagesQuantity,
        currentPage,
        setCurrentPage,
        pageSize,
        setPageSize,
        offset
    } = usePaginator({
        total: totalMember,
        initialState: {
            pageSize: 20,
            currentPage: 1
        }
    });

    useEffect(() => {
        setIsLoading(true);
        let skipCount = ((currentPage - 1) * pageSize);

        MemberService.GetAll("", skipCount, pageSize).then((res: any) => {
            if (res.result) {
                setMembers(res.result.items);
                setTotalMember(res.result.totalCount);
            }
        }).finally(() => {
            setIsLoading(false);
        });
    }, [currentPage]);

    const handleClickRow = (member: any) => {
        window.open(`/members/${member.id}`);
    };

    const handlePageChange = (nextPage: number) => {
        setCurrentPage(nextPage);
    };

    const handleSearch = (searchKey: string) => {
        let skipCount = ((currentPage - 1) * pageSize);

        MemberService.GetAll(searchKey, skipCount, pageSize).then((res: any) => {
            if (res.result) {
                setMembers(res.result.items);
                setTotalMember(res.result.totalCount);
            }
        }).finally(() => {
        });
    };

    if (isLoading)
        return <LoadingScreen/>;

    return (
        <Layout>
            <Container maxWidth={"8xl"} mt={2} mb={5}>
                <Box>
                    <Heading fontSize={'3xl'} fontWeight={"extrabold"}>Members</Heading>
                </Box>
                <Box mt={6}>
                    <LogosTableSearch handleSearch={handleSearch} />
                    <LogosTable
                        caption={''}
                        headers={[{ label: 'Nama' }, { label: 'Email' }, { label: 'No Whatsapp' }, { label: 'Tanggal Bergabung' }]}
                        rows={[{ propertyName: 'fullName', baseUrl: '/members/' }, { propertyName: 'emailAddress', baseUrl: '/members/' }, { propertyName: 'phoneNumber' }, { propertyName: 'creationTime', isDate: true }]}
                        data={members}
                        onRowClick={handleClickRow}
                    />
                    <LogosTablePagination currentPage={currentPage} pagesQuantity={pagesQuantity} handlePageChange={handlePageChange} />
                </Box>
            </Container>
        </Layout>
    );
};

export default MemberScene;